export type RegionItem = {
    id: number;          // id interno (API o base de datos)
    code: number;        // código oficial (1–16)
    roman: string;       // número romano I–XVI
    name: string;        // nombre completo
    cover_url: string;   // imagen
};

export const REGIONES: RegionItem[] = [
    { id: 109, code: 15, roman: "XV", name: "Región de Arica y Parinacota", cover_url: "https://cdn.rdx.social/p8g679f3knbuwsbwuutxp840r3h1" },
    { id: 110, code: 1, roman: "I", name: "Región de Tarapacá", cover_url: "https://cdn.rdx.social/doyi1aut9uphji31ycnfrkhxfb0o" },
    { id: 111, code: 2, roman: "II", name: "Región de Antofagasta", cover_url: "https://cdn.rdx.social/5q6unrti3zjnpw2oebcywrfh2vbf" },
    { id: 112, code: 3, roman: "III", name: "Región de Atacama", cover_url: "https://cdn.rdx.social/qhnx7elnxz7btk9d3sdxbar2pvy2" },
    { id: 113, code: 4, roman: "IV", name: "Región de Coquimbo", cover_url: "https://cdn.rdx.social/jdri5cwclq22fq5mm0b6vi3fhqa9" },
    { id: 114, code: 5, roman: "V", name: "Región de Valparaíso", cover_url: "https://cdn.rdx.social/3vv99pgg8k1jc04shcszly4wkb0u" },
    { id: 115, code: 13, roman: "RM", name: "Región Metropolitana de Santiago", cover_url: "https://cdn.rdx.social/ez1bflq3iv2491ggqfmq2pzxenc1" },
    { id: 116, code: 6, roman: "VI", name: "Región del Libertador General Bernardo O'Higgins", cover_url: "https://cdn.rdx.social/9h1tiwuedkwwlaqsbro3crasxeqj" },
    { id: 117, code: 7, roman: "VII", name: "Región del Maule", cover_url: "https://cdn.rdx.social/bbt50b6nzcl6l1jqum15ffbbffn3" },
    { id: 118, code: 16, roman: "XVI", name: "Región de Ñuble", cover_url: "https://cdn.rdx.social/8hvkjr2bfk5esn2wq7hv1wkpp5no" },
    { id: 119, code: 8, roman: "VIII", name: "Región del Biobío", cover_url: "https://cdn.rdx.social/b5z0072sh5c98e0ozk9w0lw5hc8g" },
    { id: 120, code: 9, roman: "IX", name: "Región de La Araucanía", cover_url: "https://cdn.rdx.social/mjksdpktlt2dkq5rqkfb2kbszuzi" },
    { id: 121, code: 14, roman: "XIV", name: "Región de Los Ríos", cover_url: "https://cdn.rdx.social/lbk987opn22dag8fsrgyz8mkzso8" },
    { id: 122, code: 10, roman: "X", name: "Región de Los Lagos", cover_url: "https://cdn.rdx.social/arri3l600u6wgfiyye8c6jsaz1gx" },
    { id: 123, code: 11, roman: "XI", name: "Región de Aysén del General Carlos Ibáñez del Campo", cover_url: "https://cdn.rdx.social/7w4291hedcjeltks13836jd6szf4" },
    { id: 124, code: 12, roman: "XII", name: "Región de Magallanes y de la Antártica Chilena", cover_url: "https://cdn.rdx.social/0dqv2mgmptw99qpy6d1brnt8d89p" },
];

// // Orden oficial solicitado (por code)
// export const REGION_ORDER = [
//     15, // Arica y Parinacota (XV)
//     1,  // Tarapacá (I)
//     2,  // Antofagasta (II)
//     3,  // Atacama (III)
//     4,  // Coquimbo (IV)
//     5,  // Valparaíso (V)
//     13, // Metropolitana (RM)
//     6,  // O'Higgins (VI)
//     7,  // Maule (VII)
//     16, // Ñuble (XVI)
//     8,  // Biobío (VIII)
//     9,  // Araucanía (IX)
//     14, // Los Ríos (XIV)
//     10, // Los Lagos (X)
//     11, // Aysén (XI)
//     12  // Magallanes (XII)
// ];